export default "__VITE_ASSET__BZaafX20__"